function expectedStatementSupportedRadioDirective(): ng.IDirective {
    return {
        restrict: "AE",
        replace: true,
        scope: {
            statement: "="
        },
        templateUrl: "app/funding/directives/partials/expectedStatementSummary.html"
    };
}
export = expectedStatementSupportedRadioDirective;
